<script lang="ts">
    import { select } from '@rxsv/core';

    import { Selectors } from 'portlet/store/index';
    import { getStoreContext } from 'portlet/common/contexts';

    import Header from 'header/Header.svelte';

    interface Props {
        nomenu?: boolean;
        maximized?: boolean;
        externalInfoUrlEnabled?: boolean;
        isDataToDownload?: boolean;
    }

    let {
        nomenu = false,
        maximized = false,
        externalInfoUrlEnabled = false,
        isDataToDownload = false,
    }: Props = $props();

    const store = getStoreContext();

    const title$ = store.state$.pipe(select(Selectors.portletTitleSelector));
    const subtitle$ = store.state$.pipe(select(Selectors.portletSubtitleSelector));
    const titleAlign$ = store.state$.pipe(select(Selectors.portletTitleAlignSelector));
    const jumpToAOEnabled$ = store.state$.pipe(select(Selectors.queryLinkSelector));
    const showSupportForm$ = store.state$.pipe(select(Selectors.showSupportFormSelector));
    const replacementTags$ = store.state$.pipe(select(Selectors.replacementTagsSelector));
    const interactiveTitleTags$ = store.state$.pipe(select(Selectors.interactiveTitleSelector));
    const isPerformanceLow$ = store.state$.pipe(select(Selectors.isPerformanceLowSelector));
</script>

<Header
    {nomenu}
    {maximized}
    {externalInfoUrlEnabled}
    {isDataToDownload}
    replacementTags={$replacementTags$}
    title={$title$}
    subtitle={$subtitle$}
    titleAlign={$titleAlign$}
    jumpToAOEnabled={!!$jumpToAOEnabled$}
    showSupportForm={$showSupportForm$}
    interactiveReplacementTags={$interactiveTitleTags$}
    isPerformanceLow={$isPerformanceLow$}
    on:portlet-maximize
    on:jump-to-ao
    on:portlet-menu-item-click
    on:interactive-title-change
    on:open-info-url
    on:download-data
>
    <slot name="header-prefix" slot="header-prefix" />
    <slot name="header-postfix" slot="header-postfix" />
</Header>
